import { RoleListItemsContext } from "@/context/RoleListItemsContext";
import React from "react";

export default function useRoleListItems() {
  return React.useContext(RoleListItemsContext);
}
